
import { l, tryGetTokenOverride, selectLanguage } from "./localization.js";


// Exhibitions management translations
export const exhibitions = {


    
    entry(number, locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "entry");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        switch(number) {
            case 1: return l.cms.exhibitions.singular(locale);
            default: return l.cms.exhibitions.plural(locale);
        }
            
    },
            

    
    singular(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "singular");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Exhibition";
            case "de": return "Ausstellung";
            default: return `[singular: ${language} missing]`;
        }
    
    },
            

    
    plural(locale) {

        const overrideTranslation = tryGetTokenOverride(locale, "plural");

        if (overrideTranslation) {
            return overrideTranslation;
        }
        
        const language = selectLanguage(locale, ["en", "de"]);

        switch (language) {
            case "en": return "Exhibitions";
            case "de": return "Ausstellungen";
            default: return `[plural: ${language} missing]`;
        }
    
    },
            
};
